// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(viewId) {
  return {
    viewId: viewId
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "viewId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 7
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = [
  (v3/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchingType",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ExpiredProperty",
  "abstractKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "WithdrawnProperty",
  "abstractKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRenewable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "activeUntil",
    "storageKey": null
  }
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "ActiveProperty",
  "abstractKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "dismissalState",
    "value": "UNDISMISSED"
  }
],
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "activityReport",
    "plural": false,
    "selections": (v7/*: any*/),
    "storageKey": null
  },
  (v4/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v19 = {
  "alias": "forSalePropertyMatchingType",
  "args": null,
  "kind": "ScalarField",
  "name": "matchingType",
  "storageKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    {
      "alias": "forSaleProperty",
      "args": null,
      "concreteType": "ForSalePropertyV5",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v5/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RentalPropertyV5",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        {
          "alias": "rentalPropertyMatchingType",
          "args": null,
          "kind": "ScalarField",
          "name": "matchingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Landlord",
  "abstractKey": null
},
v22 = [
  (v8/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RentalNeedV5",
      "kind": "LinkedField",
      "name": "rentalNeed",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Renter",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    (v23/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BuyerNeedV5",
          "kind": "LinkedField",
          "name": "buyerNeed",
          "plural": false,
          "selections": (v22/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Buyer",
      "abstractKey": null
    }
  ],
  "type": "ClientV5",
  "abstractKey": "__isClientV5"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/)
  ],
  "type": "Buyer",
  "abstractKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v29 = {
  "kind": "Variable",
  "name": "__dynamicKey",
  "variableName": "viewId"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v31 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyDashboardPageRelayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "MyClientsWidgetRelay_query"
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "MyDraftsWidgetDraftList_query"
      },
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "MyBroadcastMessagesWidgetList_query"
      },
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "MySharedPostsWidgetList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyDashboardPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QueryClientV5Connection",
        "kind": "LinkedField",
        "name": "accountClientsV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryClientV5Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalPropertyV5",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "propertyLocation",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "RentedProperty",
                                "abstractKey": null
                              },
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "RentalPropertyMatchConnection",
                            "kind": "LinkedField",
                            "name": "matches",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": "RentalPropertyBroadcastConnection",
                            "kind": "LinkedField",
                            "name": "broadcasts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalPropertyBroadcastEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalPropertyBroadcast",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "broadcasts(first:1)"
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "type": "Landlord",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ForSalePropertyV5",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "propertyLocation",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibilityRule",
                                    "storageKey": null
                                  }
                                ],
                                "type": "PropertyLocationWithVisibleAddress",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "SoldProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "UnderContractProperty",
                                "abstractKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": "forSaleMatchingType",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "matchingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "ForSalePropertyMatchConnection",
                            "kind": "LinkedField",
                            "name": "matches",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": "PropertyBroadcastConnection",
                            "kind": "LinkedField",
                            "name": "broadcasts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PropertyBroadcastEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ForSalePropertyBroadcast",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "broadcasts(first:1)"
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "type": "Seller",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientContactsConnection",
                        "kind": "LinkedField",
                        "name": "contacts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientContactsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientContactV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "clientAccessStatus",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedV5",
                        "kind": "LinkedField",
                        "name": "buyerNeed",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "autoNotify",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "ActiveBuyerNeed",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": "buyerNeedMatchingType",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "matchingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "BuyerNeedMatchConnection",
                            "kind": "LinkedField",
                            "name": "matches",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": "BuyerNeedBroadcastConnection",
                            "kind": "LinkedField",
                            "name": "broadcasts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedBroadcastEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuyerNeedBroadcast",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "broadcasts(first:1)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v23/*: any*/),
                          (v25/*: any*/)
                        ],
                        "type": "ClientV5",
                        "abstractKey": "__isClientV5"
                      }
                    ],
                    "type": "Buyer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedV5",
                        "kind": "LinkedField",
                        "name": "rentalNeed",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "ActiveRentalNeed",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "RentalNeedMatchConnection",
                            "kind": "LinkedField",
                            "name": "matches",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": "RentalNeedBroadcastConnection",
                            "kind": "LinkedField",
                            "name": "broadcasts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedBroadcastEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedBroadcast",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "broadcasts(first:1)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedV5",
                                "kind": "LinkedField",
                                "name": "rentalNeed",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Renter",
                            "abstractKey": null
                          },
                          (v25/*: any*/)
                        ],
                        "type": "ClientV5",
                        "abstractKey": "__isClientV5"
                      }
                    ],
                    "type": "Renter",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": "accountClientsV5(first:7)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "MyClientsWidgetRelayQuery_accountClientsV5",
        "kind": "LinkedHandle",
        "name": "accountClientsV5",
        "dynamicKey": (v29/*: any*/)
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QueryDraftsForCurrentAccountV5Connection",
        "kind": "LinkedField",
        "name": "draftsForCurrentAccountV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryDraftsForCurrentAccountV5ConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftV5",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "origin",
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "publishedProperty",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DraftPropertyV5",
                    "kind": "LinkedField",
                    "name": "draftProperty",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Area",
                        "kind": "LinkedField",
                        "name": "userSelectedArea",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": "draftsForCurrentAccountV5(first:7)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "MyDraftsWidgetDraftList_query_draftsForCurrentAccountV5",
        "kind": "LinkedHandle",
        "name": "draftsForCurrentAccountV5",
        "dynamicKey": (v29/*: any*/)
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QueryMessageBroadcastsForCurrentUserConnection",
        "kind": "LinkedField",
        "name": "messageBroadcastsForCurrentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryMessageBroadcastsForCurrentUserConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageBroadcast",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CategoryV5",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "broadcastAt",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": "messageBroadcastsForCurrentUser(first:5)"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "MyBroadcastMessagesWidgetList_query_messageBroadcastsForCurrentUser",
        "kind": "LinkedHandle",
        "name": "messageBroadcastsForCurrentUser",
        "dynamicKey": (v29/*: any*/)
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QuerySharedPostsForCurrentUserV5Connection",
        "kind": "LinkedField",
        "name": "sharedPostsForCurrentUserV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QuerySharedPostsForCurrentUserV5ConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyLocation",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v34/*: any*/)
                            ],
                            "type": "PropertyLocationWithHiddenAddress",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v32/*: any*/),
                              (v34/*: any*/)
                            ],
                            "type": "PropertyLocationWithVisibleAddress",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 20
                          }
                        ],
                        "concreteType": "SharedPropertyV5ContactsConnection",
                        "kind": "LinkedField",
                        "name": "contacts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SharedPropertyV5ContactsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lastName",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SharingContactClientContactV5",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "email",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SharingContactFreshContactV5",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "contacts(first:20)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "SharedPropertyV5",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/)
        ],
        "storageKey": "sharedPostsForCurrentUserV5(first:5)"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "MySharedPostsList_query_sharedPostsForCurrentUserV5",
        "kind": "LinkedHandle",
        "name": "sharedPostsForCurrentUserV5",
        "dynamicKey": (v29/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "38d32c720540d0a386e760f59b2edd95",
    "id": null,
    "metadata": {},
    "name": "MyDashboardPageRelayQuery",
    "operationKind": "query",
    "text": "query MyDashboardPageRelayQuery {\n  ...MyClientsWidgetRelay_query_1752XP\n  ...MyDraftsWidgetDraftList_query_1752XP\n  ...MyBroadcastMessagesWidgetList_query_3OVASn\n  ...MySharedPostsWidgetList_query_3OVASn\n}\n\nfragment MyBroadcastMessagesWidgetListItem_message on MessageBroadcast {\n  id\n  category {\n    name\n  }\n  subject\n  broadcastAt\n}\n\nfragment MyBroadcastMessagesWidgetList_query_3OVASn on Query {\n  messageBroadcastsForCurrentUser(first: 5) {\n    edges {\n      node {\n        nodeId\n        ...MyBroadcastMessagesWidgetListItem_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MyClientsWidgetBuyer_Menu_buyer on Buyer {\n  id\n  buyerNeed {\n    id\n    nodeId\n    buyerNeedMatchingType: matchingType\n    status {\n      __typename\n      ... on ActiveBuyerNeed {\n        isRenewable\n      }\n      ... on ExpiredBuyerNeed {\n        __typename\n      }\n      ... on InContractBuyerNeed {\n        __typename\n      }\n      ... on PurchasedBuyerNeed {\n        __typename\n      }\n      ... on WithdrawnBuyerNeed {\n        __typename\n      }\n    }\n    matches(dismissalState: UNDISMISSED) {\n      totalCount\n    }\n    broadcasts(first: 1) {\n      edges {\n        node {\n          activityReport {\n            __typename\n            ... on ActivityReportV5 {\n              __typename\n            }\n          }\n          nodeId\n        }\n      }\n    }\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetBuyer_buyer on Buyer {\n  ...MyClientsWidgetBuyer_name_buyer\n  ...MyClientsWidgetBuyer_status_buyer\n  ...MyClientsWidgetBuyer_Menu_buyer\n}\n\nfragment MyClientsWidgetBuyer_name_buyer on Buyer {\n  id\n  displayName\n  contacts {\n    edges {\n      node {\n        clientAccessStatus {\n          __typename\n          ... on ClientContactInvited {\n            __typename\n          }\n          ... on ClientContactRegistered {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n  buyerNeed {\n    matchingType\n    autoNotify\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetBuyer_status_buyer on Buyer {\n  buyerNeed {\n    ...OwnBuyerNeedStatusLabel_buyerNeedV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetDeleteDialog_clientV5 on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  ... on Seller {\n    canDelete\n    forSaleProperty: property {\n      forSalePropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Landlord {\n    canDelete\n    property {\n      rentalPropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Renter {\n    canDelete\n    rentalNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Buyer {\n    canDelete\n    buyerNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n}\n\nfragment MyClientsWidgetLandlord_Menu_landlord on Landlord {\n  id\n  property {\n    id\n    nodeId\n    status {\n      __typename\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on RentedProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n      ... on ActiveProperty {\n        isRenewable\n      }\n    }\n    matches(dismissalState: UNDISMISSED) {\n      totalCount\n    }\n    broadcasts(first: 1) {\n      edges {\n        node {\n          activityReport {\n            __typename\n            ... on ActivityReportV5 {\n              __typename\n            }\n          }\n          nodeId\n        }\n      }\n    }\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetLandlord_landlord on Landlord {\n  ...MyClientsWidgetLandlord_name_landlord\n  ...MyClientsWidgetLandlord_Menu_landlord\n  ...MyClientsWidgetLandlord_status_landlord\n}\n\nfragment MyClientsWidgetLandlord_name_landlord on Landlord {\n  displayName\n  id\n  property {\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        __typename\n      }\n    }\n    matchingType\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetLandlord_status_landlord on Landlord {\n  property {\n    ...OwnRentalPropertyStatusLabel_rentalPropertyV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetRelay_query_1752XP on Query {\n  accountClientsV5(first: 7) {\n    edges {\n      node {\n        __typename\n        ... on Landlord {\n          id\n          ...MyClientsWidgetLandlord_landlord\n        }\n        ... on Seller {\n          id\n          ...MyClientsWidgetSeller_seller\n        }\n        ... on Buyer {\n          id\n          ...MyClientsWidgetBuyer_buyer\n        }\n        ... on Renter {\n          id\n          ...MyClientsWidgetRenter_renter\n        }\n        nodeId\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MyClientsWidgetRenter_Menu_renter on Renter {\n  id\n  rentalNeed {\n    id\n    nodeId\n    status {\n      __typename\n      ... on ActiveRentalNeed {\n        isRenewable\n      }\n      ... on ExpiredRentalNeed {\n        __typename\n      }\n      ... on RentedRentalNeed {\n        __typename\n      }\n      ... on WithdrawnRentalNeed {\n        __typename\n      }\n    }\n    matches(dismissalState: UNDISMISSED) {\n      totalCount\n    }\n    broadcasts(first: 1) {\n      edges {\n        node {\n          activityReport {\n            __typename\n            ... on ActivityReportV5 {\n              __typename\n            }\n          }\n          nodeId\n        }\n      }\n    }\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetRenter_name_renter on Renter {\n  id\n  displayName\n}\n\nfragment MyClientsWidgetRenter_renter on Renter {\n  ...MyClientsWidgetRenter_name_renter\n  ...MyClientsWidgetRenter_status_renter\n  ...MyClientsWidgetRenter_Menu_renter\n}\n\nfragment MyClientsWidgetRenter_status_renter on Renter {\n  rentalNeed {\n    ...OwnRentalNeedStatusLabel_rentalNeedV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetSeller_Menu_seller on Seller {\n  id\n  property {\n    id\n    nodeId\n    forSaleMatchingType: matchingType\n    status {\n      __typename\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on ActiveProperty {\n        isRenewable\n      }\n      ... on SoldProperty {\n        archived\n      }\n      ... on UnderContractProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n    }\n    matches(dismissalState: UNDISMISSED) {\n      totalCount\n    }\n    broadcasts(first: 1) {\n      edges {\n        node {\n          activityReport {\n            __typename\n            ... on ActivityReportV5 {\n              __typename\n            }\n          }\n          nodeId\n        }\n      }\n    }\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetSeller_name_seller on Seller {\n  displayName\n  id\n  property {\n    forSalePropertyMatchingType: matchingType\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithVisibleAddress {\n        visibilityRule\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetSeller_seller on Seller {\n  ...MyClientsWidgetSeller_name_seller\n  ...MyClientsWidgetSeller_status_seller\n  ...MyClientsWidgetSeller_Menu_seller\n}\n\nfragment MyClientsWidgetSeller_status_seller on Seller {\n  property {\n    ...OwnForSalePropertyStatusLabel_forSalePropertyV5\n    nodeId\n  }\n}\n\nfragment MyDraftsWidgetDraftListItem_draft on DraftV5 {\n  origin\n  databaseId\n  updatedAt\n  publishedProperty {\n    __typename\n    id\n    nodeId\n  }\n  draftProperty {\n    address\n    userSelectedArea {\n      name\n      nodeId\n    }\n  }\n}\n\nfragment MyDraftsWidgetDraftList_query_1752XP on Query {\n  draftsForCurrentAccountV5(first: 7) {\n    edges {\n      node {\n        nodeId\n        ...MyDraftsWidgetDraftListItem_draft\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MySharedPostsWidgetListItemSharedProperty_sharedProperty on SharedPropertyV5 {\n  databaseId\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      address\n      locationDisplay\n    }\n  }\n  contacts(first: 20) {\n    edges {\n      node {\n        __typename\n        ... on SharingContactClientContactV5 {\n          databaseId\n          firstName\n          lastName\n        }\n        ... on SharingContactFreshContactV5 {\n          databaseId\n          email\n        }\n      }\n    }\n  }\n  createdAt\n  property {\n    __typename\n    id\n    nodeId\n  }\n}\n\nfragment MySharedPostsWidgetList_query_3OVASn on Query {\n  sharedPostsForCurrentUserV5(first: 5) {\n    edges {\n      node {\n        __typename\n        ... on SharedPropertyV5 {\n          databaseId\n          ...MySharedPostsWidgetListItemSharedProperty_sharedProperty\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment OwnBuyerNeedStatusLabel_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment OwnForSalePropertyStatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      __typename\n      archived\n    }\n    ... on SoldProperty {\n      __typename\n      archived\n    }\n    ... on UnderContractProperty {\n      __typename\n      archived\n    }\n    ... on WithdrawnProperty {\n      __typename\n      archived\n    }\n  }\n}\n\nfragment OwnRentalNeedStatusLabel_rentalNeedV5 on RentalNeedV5 {\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment OwnRentalPropertyStatusLabel_rentalPropertyV5 on RentalPropertyV5 {\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      archived\n    }\n    ... on RentedProperty {\n      archived\n    }\n    ... on WithdrawnProperty {\n      archived\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
